export default "__VITE_ASSET__B6P4QTBD__"